export default __webpack_public_path__ + "static/media/A.1cedeef7.svg";